import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=fbacf6a2&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=fbacf6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbacf6a2",
  null
  
)

export default component.exports